module.exports = __webpack_public_path__ + "static/media/YM65_4.28050699.jpg";